module.exports = __webpack_public_path__ + "img/item1.c6082659.png";